export default __webpack_public_path__ + "static/media/lipstick1.0db2f087.jpg";